import { Route, Switch } from 'react-router-dom';
import { LoadComponent } from '@yooink/youtils/es/LoadComponent';
import withErrorCatcher from '@yooink/youtils/es/WithErrorCatcher';
import { addPropsToComponent } from '@yooink/youtils/es/AddPropsToComponent';
import PropTypes from 'prop-types';

const List = LoadComponent(() => import('./List'));
const View = LoadComponent(() => import('./ChangesHistory'));
const ViewAsTimeline = LoadComponent(() => import('./ChangesHistory/timeline'));

const ActionLoggerRoute = (props) => {
	const basePath = props.path || '/actionlogger';
	const getPath = (path = '') => `${basePath}${path}`;

	const chain = (component) => withErrorCatcher(addPropsToComponent({
		basePath
	}, component));

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={chain(List)}
			/>
			<Switch>
				<Route
					exact
					path={getPath('/:id/timeline')}
					component={chain(ViewAsTimeline)}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={chain(View)}
				/>
			</Switch>
		</>
	);
};

ActionLoggerRoute.propTypes = {
	path: PropTypes.string
};

export { ActionLoggerRoute };
